import { Box, HStack, Image, Text, Tooltip } from '@chakra-ui/react';
import Map from '../../components/map/Map';
import { Sidebar } from '../../components/sidebar/Sidebar';
import { Icon } from '@blueprintjs/core';
import { useContext, useEffect, useState } from 'react';
import UIContext from '../../context/UIContext';
import AttributionsModal from '../../components/AttributionsModal';
import DisclaimerModal, { hasAcceptedDisclaimer } from '../../components/DisclaimerModal';
import useIsDemo from '../../hooks/useIsDemo';
import useIsChartCoverageDemo from '../../hooks/useIsChartCoverageDemo';

function RootScreen() {
    const {
        attributionsOpen, setAttributionsOpen
    } = useContext(UIContext);
    const isDemo = useIsDemo();
    const isChartCoverageDemo = useIsChartCoverageDemo();
    const [disclaimerOpen, setDisclaimerOpen] = useState(false);
    const [disclaimerRequireAgreement, setDisclaimerRequireAgreement] = useState(false);

    useEffect(() => {
        if (isDemo || isChartCoverageDemo) {
            return;
        }
        if (!hasAcceptedDisclaimer()) {
            setDisclaimerRequireAgreement(true);
            setDisclaimerOpen(true);
        }
    }, [isDemo, isChartCoverageDemo]);

    return (
        <Box position="absolute" top="0px" bottom="0px" left="0px" right="0px" display="flex" flexDir="row">
            <Sidebar></Sidebar>
            {/* <Box
                bg="black"
                position="absolute"
                top="10px"
                right="10px"
                w="30px"
                h="30px"
                zIndex={2}
                display="flex"
                flexDir="row"
                justifyContent="center"
                alignItems="center"
                borderRadius="4px"
                boxShadow="0px 0px 0px 2px rgba(0,0,0,0.1)"
                cursor="pointer"
                // opacity="0.5"
            >
                <Image src="/public/img/logo-icon.svg" w="16px"></Image>
            </Box> */}

            <HStack
                position="absolute"
                bottom="10px"
                left="10px"
                zIndex={2}
                spacing="0px"
                bg="rgba(255,255,255,0.65)"
                borderRadius="4px"
                boxShadow="0px 0px 0px 2px rgba(0,0,0,0.1)"
                overflow="hidden"
            >
                <Tooltip placement="top" label="Data Attributions">
                    <Box
                        w="30px"
                        h="30px"
                        bg="white"
                        display="flex"
                        flexDir="row"
                        justifyContent="center"
                        alignItems="center"
                        cursor="pointer"
                        _hover={{
                            bg: "rgba(245,245,245,1.0)"
                        }}
                        borderRight="1px solid rgba(0,0,0,0.1)"
                        onClick={() => {
                            setAttributionsOpen(true);
                        }}
                    >
                        <Text mb="0px" opacity="0.4">
                            <Icon icon="info-sign"></Icon>
                        </Text>
                    </Box>
                </Tooltip>
                    <Box
                        h="30px"
                        px="8px"
                        display="flex"
                        alignItems="center"
                        borderRadius="4px"
                        borderTopLeftRadius="0px"
                        borderBottomLeftRadius="0px"
                        cursor="pointer"
                        _hover={{
                            bg: "rgba(0,0,0,0.03)"
                        }}
                        onClick={() => {
                            setDisclaimerRequireAgreement(false);
                            setDisclaimerOpen(true);
                        }}
                    >
                        <Text mb="0px" fontSize="12px" fontWeight="500" opacity="0.55" whiteSpace="nowrap">
                            Not for nav
                        </Text>
                    </Box>
            </HStack>
            <Map></Map>
            <AttributionsModal isOpen={attributionsOpen} onClose={() => setAttributionsOpen(false)}></AttributionsModal>
            <DisclaimerModal
                isOpen={disclaimerOpen}
                onClose={() => setDisclaimerOpen(false)}
                requireAgreement={disclaimerRequireAgreement}
            />
        </Box>
    );
}

export default RootScreen;
